// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"a490e93d","48":"d08b91d7","167":"ba430b2c","257":"47286a7c","327":"28b8e8b1","398":"bceb909b","413":"d0011e53","585":"d4f2c32e","682":"5f26d9da","683":"5f8c591b","867":"f3742cb2","924":"cafc9a22","937":"f73c29a2"}[chunkId] + ".chunk.js";
};